module.exports = __webpack_public_path__ + "img/stoneholder-2@2x.efcc3dd.png";